<template>
  <DeleteReportsTable title="Список отчётов" :delete-event-id="deleteEventId"/>
</template>

<script>
import DeleteReportsTable from "@/components/tables/DeleteReportsTable.vue";

export default {
  name: 'DeleteReportsTableDialog',
  components: {DeleteReportsTable},
  inject: ['dialogRef'],
  data() {
    return {
      deleteEventId: null
    }
  },
  beforeMount() {
    const params = this.dialogRef.data;
    this.deleteEventId = params.deleteEventId;
  }
}
</script>
